import maEventBus from '@/components/eventbus/index.js'

import debounce from '@/utils/debounce'

import maForm from '@/components/form'
import maEventbus from '@/components/eventbus'
import maModal from '@/components/modal'
import maSearchMobilier from './components/searchMobilier'

import {
  MA_WARRANTY_WATER_MOBILIER,
  ROOM_SURFACE,
  UPDATE_PIECES_SURFACE
} from '@/constants'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_UPDATE_CREATED
} from '@/store/types'

import { apiGetForm } from '@/services/API/menus'
import { apiPostDamage, apiPatchDamage } from '@/services/API/damages'
import * as Settings from '@/infra/settings'

export default {
  name: 'warrantyView',
  data: function() {
    return {
      form: {},
      damage: {
        asset_damages: 0
      },
      activeInput: '',
      activeInputValue: '',
      addDamageBtnIsHidden: false,
      isLoaderActive: false
    }
  },

  components: {
    maForm,
    maEventbus,
    maModal,
    maSearchMobilier
  },

  computed: {
    ...mapState({
      agentView: state => state.agentView
    }),
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyCreated: 'created',
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyaddress: 'address'
    }),
    ...mapState({
      lastPieceSelected: state => state.warranty.lastPieceSelected
    }),
    comWarrantyCreated: {
      get() {
        return this.stateWarrantyCreated
      },
      set(v) {
        this.mutWarrantyUpdateCreated(v)
      }
    },

    warrantyId: function() {
      return this.$route.meta.id
    },

    disableAddDamageButton: function() {
      if (this.stateUserIsReduxMode) {
        return (
          !this.stateWarrantySinisterId ||
          this.stateWarrantySinisterId.lenght <= 0 ||
          !this.stateWarrantyZipCode ||
          this.stateWarrantyZipCode.lenght <= 0
        )
      }

      return (
        !this.stateWarrantySinisterId ||
        this.stateWarrantySinisterId.lenght <= 0 ||
        !this.stateWarrantyCoordinates ||
        this.stateWarrantyCoordinates.lat.lenght <= 0 ||
        this.stateWarrantyCoordinates.lng.length <= 0 ||
        !this.stateWarrantyZipCode ||
        this.stateWarrantyZipCode.lenght <= 0
      )
    },

    warrantyid: function() {
      return this.$route.meta.warrantyid || ''
    },

    warrantyCategory: function() {
      return this.$route.meta.warranty_subtype_id
    },

    isMobilierRoute() {
      return this.$route.name === MA_WARRANTY_WATER_MOBILIER
    },

    externalDamageId: function() {
      return this.FNOLFlow.params.externalDamageId
        ? this.FNOLFlow.params.externalDamageId
        : null
    },

    pieceId: function() {
      if (this.damage.PIECE) {
        return this.lastPieceSelected.piece_id || 1
      }

      return undefined
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY
    }),
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateCreated: WARRANTY_UPDATE_CREATED
    }),

    openModal(ref) {
      this.$refs[ref].$data.showModal = true
    },

    handleFormChange: debounce(async function(event) {
      if (event.inpTextNumbers) {
        const inputValParsed = event.inputVal.replace(',', '.')
        this.damage[event.inputId] = inputValParsed
      } else {
        this.damage[event.inputId] = event.inputVal
      }

      if (event.inputId !== ROOM_SURFACE) {
        await this.updateForm()
        this.updatePiecesSurface()
      }
    }, 50),

    updateForm: debounce(function() {
      const sinisterInfo = {
        sinisterId: this.stateWarrantySinisterId,
        zipCode: this.stateWarrantyZipCode,
        propertyType: this.stateWarrantyPropertyType
      }
      this.damage['SINISTER_INFO'] = sinisterInfo
      const body = { ...this.damage }
      const formInputs = document.querySelectorAll('.warranty__content input')

      delete body['asset_damages']

      formInputs.forEach(function(el) {
        el.disabled = true
      })

      return apiGetForm(this.warrantyId, body)
        .then(data => {
          this.form = null
          this.$nextTick(() => {
            this.form = data.form
            this.setDefaultValues()
            this.$nextTick(() => {
              this.handleUpdateForm()
            })
          })
        })
        .finally(() => {
          formInputs.forEach(function(el) {
            el.disabled = false
          })
        })
    }, 100),

    clearForm: function() {
      this.damage = {}
      this.form = {}
      this.updateForm()
    },

    setWatchers: function() {
      let vm = this
      vm.$watch('warrantyId', function() {
        this.updateForm()
        this.clearForm()
      })
    },

    setDefaultValues: function() {
      this.damage = {}
      this.damage.asset_damages = this.form.asset_damages || ''

      this.form.regions.forEach(region => {
        region.inputs.forEach(input => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    addDamage: async function(body) {
      if (!this.comWarrantyCreated) {
        return apiPostDamage(body)
      }

      return apiPatchDamage(body)
    },

    handleAddDamage: debounce(function() {
      let damageBody = {
        sinister_id: this.stateWarrantySinisterId,
        event_id: this.stateWarrantySecondaryId,
        category: this.warrantyid,
        subcategory: this.warrantyCategory,
        external_damage_id: this.externalDamageId,
        form_info: { ...this.damage },
        piece_id: this.pieceId
      }

      if (!this.comWarrantyCreated) {
        damageBody = {
          ...damageBody,
          zip_code: this.stateWarrantyZipCode,
          real_estate: this.stateWarrantyPropertyType,
          declarant: this.stateWarrantyResidentType,
          more_than_two_years: this.stateWarrantyMoreThanTwoYears,
          address: this.stateWarrantyAddress
        }

        if (!this.stateUserIsReduxMode) {
          damageBody = {
            ...damageBody,
            lat: this.stateWarrantyCoordinates.lat,
            lon: this.stateWarrantyCoordinates.lng
          }
        }
      }

      // 400 campos faltan, 500 generico
      this.addDamage(damageBody)
        .then(this.handleAddDamageSuccess)
        .catch(this.handleAddDamageError)
    }, 50),

    handleInputFocus: function(value) {
      const focusedInput = document.querySelector('input:focus')
      if (document.querySelector('input:focus') !== null) {
        this.activeInput = focusedInput
      }
    },

    /* handleInputClick: function() {
      this.isLoaderActive = true
    },
 */
    handleUpdateForm: function() {
      if (this.activeInput !== '') {
        const activeInputType = this.activeInput.getAttribute('type')
        const activeInputName = this.activeInput.getAttribute('name')
        const activeInputValue = this.damage[activeInputName]
        if (
          activeInputType === 'checkbox' &&
          this.activeInput.hasAttribute('isSelect')
        ) {
          document.querySelector('input[name=' + activeInputName + ']').focus()
          document.querySelector('input[name=' + activeInputName + ']').blur()
        } else if (activeInputType === 'text') {
          document.querySelector('input[name=' + activeInputName + ']').focus()
        } else {
          const el = document.querySelector(
            'input[value="' + activeInputValue + '"]'
          )
          if (el) el.focus()
        }
      }
    },

    handleAddDamageSuccess: debounce(async function() {
      this.throwNotification(
        this.$t('notifications.addDamage.title'),
        this.$t('notifications.addDamage.body'),
        'OK'
      )

      maEventbus.$emit('damage:closeAccordion')
      if (!this.comWarrantyCreated) {
        this.comWarrantyCreated = true
      } else {
        maEventBus.$emit('summary:collapse')
      }

      await this.actWarrantyGetSinisterSummary()
      await this.updateForm()
    }, 100),

    handleAddDamageError: function(err) {
      const errs = [400, 500, 409]
      const errCode = errs.find(errCode => err.response.status === errCode) || 0
      this.throwNotification(
        this.$t(`notifications.error.${errCode}.title`),
        err.response.data.detail,
        'KO'
      )
    },

    updatePiecesSurface: function() {
      maEventBus.$emit(UPDATE_PIECES_SURFACE)
    }
  },

  mounted: function() {
    this.updateForm()
    this.setWatchers()
    maEventBus.$on('iframeUptec:visible', () => {
      this.addDamageBtnIsHidden = true
    })
    maEventBus.$on('iframeUptec:hidden', () => {
      this.addDamageBtnIsHidden = false
    })

    maEventbus.$on('new:sinister', () => {
      this.clearForm()
    })

    maEventBus.$on('openSurfaceModal', () => {
      this.$refs.surfaceModal.$data.showModal = true
    })

    maEventbus.$on('inputWarranty:focus', $event => {
      this.handleInputFocus($event)
    })
    maEventBus.$emit('props:resize')
  }
}
